export default {"src":"/_next/static/media/Developer.e30b6400.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};